import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    headerAttribute: {
        fontSize: '.9rem',
        lineHeight: '1.2rem',
        fontWeight: 'bold' as const,
        textTransform: 'uppercase' as const
    },
    messageContent: {
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3',
        padding: '.5rem 1rem'
    },
    messageHtml: { wordBreak: 'break-all' as const },
    messageDateTimeContainer: {
        width: 'auto' as const,
        padding: '0 1rem'
    },
    messageDateContainer: {
        border: `2px solid ${theme?.app?.applicationColors.enumColors.offWhite ||
        '#F3F3F3'}`,
        borderRadius: '3px'
    },
    messageDateMonthDay: { fontSize: '1.8rem' },
    messageDateMonth: {
        fontSize: '1.4rem',
        textTransform: 'uppercase' as const
    }
});